import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {WidgetDpiaV0DataGravityValues} from './models/widget-dpia-v0-data';

@Component({
  selector: 'pt-widget-dpia-v0-gravity-value-selector',
  template: `
    <ng-select
      bindValue='value'
      bindLabel='label'
      [(ngModel)]='currentValue'
      [ngClass]='currentClassCss'
      (ngModelChange)='changeCurrentValue($event)'
      [ngModelOptions]='{standalone: true}'
      [searchable]='false'
      [clearable]='false'
      appendTo='body'>
      <ng-option *ngFor='let option of options'
                 [value]='option.value'>
        {{option.label}}
      </ng-option>
    </ng-select>
  `,
  styles: [`

    .very-high {
      border: solid 2px var(--ptHigh);
      border-radius: 6px;
    }

    .high {
      border: solid 2px var(--ptHigh);
      border-radius: 6px;
    }

    .medium-high {
      border: solid 2px var(--ptMediumHigh);
      border-radius: 6px;
    }

    .medium {
      border: solid 2px var(--ptMedium);
      border-radius: 6px;
    }

    .medium-low {
      border: solid 2px var(--ptMediumLow);
      border-radius: 6px;
    }

    .low {
      border: solid 2px var(--ptLow);
      border-radius: 6px;
    }

  `]
})
export class WidgetDpiaV0GravityValueSelectorComponent implements OnChanges {
  @Input() options: WidgetDpiaV0DataGravityValues[];
  @Input() value: number;
  @Output() changeValue = new EventEmitter<number>();

  currentClassCss = '';
  currentValue: number;

  static cssValutationResponse(iResponse: number) {
    switch (iResponse) {
      case 5:
        return 'high';
      case 4:
        return 'medium-high';
      case 3:
        return 'medium';
      case 2:
        return 'medium-low';
      case 1:
        return 'low';
      case 0:
        return 'text-muted';
    }
    return '';
  }


  changeCurrentValue(newValue: number) {
    this.updateCurrentValue(newValue);
    this.changeValue.emit(newValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.updateCurrentValue(changes.value.currentValue);
    }
  }

  private updateCurrentValue(value: number) {
    this.currentValue = value;
    this.currentClassCss = WidgetDpiaV0GravityValueSelectorComponent.cssValutationResponse(this.currentValue);
  }


}
